<template>
  <!-- page-intro -->
  <!--    <SSLView-->
  <!--        v-if="currentName === 'SSLView'"-->
  <!--        @acted="acted"-->
  <!--    />-->
  <!--    <template v-else>-->
  <div class="page-intro">
    <div class="intro-content">
      <div class="page-component center-align" style="display: flex;flex-direction: row">
        <img src="@/assets/lxp/images/ssl/reward/reward_leaf_black_L.png" alt="" style="width:90px;margin-right: 130px;">
        <h2 class="intro-title black-title" style="position: absolute">
          상반기 SSL AWARDS
        </h2>
        <img src="@/assets/lxp/images/ssl/reward/reward_leaf_black_R.png" alt="" style="width:90px;margin-left: 130px;">
<!--        <h2 class="intro-title">쓸스튜디오</h2>-->
<!--        <h2 class="intro-title">상반기 우수 학습노트</h2>-->
      </div>
    </div>
    <div class="intro-background"></div>
  </div>
  <!-- //page-intro -->
  <!-- page-container -->
  <div class="page-container">

    <div class="page-body">

<!--      <div class="myssl-container">-->
        <div class="page-component">
          <!-- page-aside -->
          <SSLRewardMember/>
          <SSLRewardBoard
              :is-loading="isLoading"
              :items="viewBoardItems"
              :paging="paging"
              :more-func="moreFunc">
            <template v-slot:top-option>
              <div class="top-column">
                <div class="tabs">
                  <ul class="tab-list">
                    <li lass="tab-item" :class="{'is-active': selTap == 0}" :key="-1">
                      <span class="tab-text kb-mouse-cursor" @click="goFilter(0)">전체</span>
                    </li>
                    <li v-for="(rwdPart, idx) in rewardParts" class="tab-item" :class="{'is-active': selTap === rwdPart.lrnTrgtGrpMstSn}" :key="idx">
                        <span class="tab-text kb-mouse-cursor" @click="goFilter(rwdPart.lrnTrgtGrpMstSn)">{{ rwdPart.crseNm }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="top-column" style="width:355px"></div>
            </template>
          </SSLRewardBoard>
        </div>
<!--      </div>-->
    </div>
    <!-- page-footer -->
    <div class="page-footer">
      <div class="page-component"></div>
    </div>
  </div>
  <!-- //page-container -->
</template>

<!--</template>-->

<script>
import {sslRewardNoteSetup} from "@/assets/js/modules/ssl/setup/ssl-best-note-setup";
import SSLRewardMember from "@/components/ssl/reward/SSLRewardMember.vue";
import SSLRewardBoard from "@/components/ssl/reward/SSLRewardBoard.vue";

export default {
  name: 'SSLRewardNote',
  components: {
    SSLRewardMember,
    SSLRewardBoard
  },
  setup: sslRewardNoteSetup
}
</script>
